import DbService from 'resources/db.service';

import schema from './document.schema';
import { DOCUMENT_TYPES } from './document.constants';

const service = new DbService('documents', { schema });

// EXAMPLE (remove after first real method will be created)
const createDealDocument = async ({
  documentId,
  dealId,
  taskId,
  clientId,
}) => {
  const doc = await service.findById(documentId);

  return service.create({
    created_on: doc.created_on,
    updated_on: doc.updated_on,
    company_id: doc.company_id,
    file_url: doc.file_url,
    name: doc.name,

    deal_id: dealId,
    task_id: taskId,
    client_id: clientId,

    type: DOCUMENT_TYPES.DEAL,
  });
};

const updateDocument = async (data) => {
  const response = await service
    .updateOne({ id: data.id }, data);

  if (response.isBadRequest) {
    return null;
  }

  return response.data[0];
};

const getByTaskId = async (taskId) => {
  // let response = await service
  //   .select()
  //   .not('task_id', 'is', null)
  //   .match({
  //     task_id: taskId,
  //   });

  let response = await service.selectByKey({
    selectKey: 'getDocumentsByTaskId',
    params: { taskId },
  });

  response = service.processResponse(response);

  return response.data.length > 0 ? response.data : null;
};

const findByIds = async (ids) => {
  // let response = await service
  //   .select()
  //   .in('id', ids);

  let response = await service.publicSelectByKey({
    selectKey: 'findDocumentsByIds',
    params: { ids },
  });

  response = service.processResponse(response);

  return response.data.length > 0 ? response.data : null;
};

const getByTaskIds = async (taskIds) => {
  // let response = await service
  //   .select()
  //   .not('task_id', 'is', null)
  //   .in('task_id', taskIds);

  let response = await service.publicSelectByKey({
    selectKey: 'getDocumentsByTaskIds',
    params: { taskIds },
  });

  response = service.processResponse(response);

  return response.data.length > 0 ? response.data : null;
};

const getByTemplateId = async (templateId) => {
  // let response = await service
  //   .select()
  //   .not('template_id', 'is', null)
  //   .match({
  //     template_id: templateId,
  //     type: DOCUMENT_TYPES.TEMPLATE,
  //   });

  let response = await service.selectByKey({
    selectKey: 'getDocumentsByTemplateId',
    params: { templateId },
  });

  response = service.processResponse(response);

  return response.data.length > 0 ? response.data : null;
};

export default Object.assign(service, {
  createDealDocument,
  updateDocument,
  getByTaskId,
  getByTemplateId,
  getByTaskIds,
  findByIds,
});
